import styled from 'styled-components';

const ActionButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding: 4px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    color: ${({action}) => (action === 'add' ? '#27ae60' : '#e74c3c')};
  }
`;

export default ActionButton;
